<script>
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();
    
    function closeMenu() {
        dispatch('close-menu', null);
    }
</script>

<div class="close_menu_cnt">
    <button class="close_menu" on:click={ closeMenu }>
        <svg version="1.1"xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
            y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
            <title>Close</title>
            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
                <path d="M147,4972C66,4891,0,4820,0,4815c0-6,505-515,1122-1132l1123-1123L1122,1437C505,820,0,310,0,305C0,292,292,0,305,0
                    c6,0,515,505,1132,1122l1123,1123l1123-1123C4300,505,4810,0,4815,0c13,0,305,292,305,305c0,6-505,515-1122,1132L2875,2560
                    l1123,1123c617,617,1122,1126,1122,1132c0,13-292,305-305,305c-5,0-515-505-1132-1122L2560,2875L1437,3998
                    C820,4615,310,5120,305,5120C299,5120,228,5054,147,4972z"/>
            </g>
        </svg>
    </button>
</div>